export const initialJourneyDetails = {
	source: '',
	destination: '',
	travellers: '',
	carType: '',
};

export const initialBidDetails = {
	price: '',
	mobile: '',
	name: '',
	remarks: '',
	isRateNegotiable: true,
	getUpdates: true,
};

export const otpValues = {
	firstDigit: '',
	secondDigit: '',
	thirdDigit: '',
	fourthDigit: '',
};
